export default __webpack_public_path__ + "static/media/kitchen5-beforeB-1024w.a9d9e8d9.png";